import { AfterViewInit, Directive, ElementRef, inject, input, Renderer2 } from '@angular/core';
import { SopoTooltipService } from '../../services/sopoTooltip/sopo-tooltip.service';

@Directive({
    selector: '[appSopoTooltip]',
    host: {
        '(click)': 'onClick()',
    },
    standalone: true,
})
export class SopoTooltipDirective implements AfterViewInit {
    private _elementRef = inject(ElementRef);
    private _renderer2 = inject(Renderer2);
    appSopoTooltip = input.required<string>();

    constructor(
        private sopoTooltipService: SopoTooltipService,
    ) { }

    ngAfterViewInit(): void {
        if (this._elementRef?.nativeElement) {
            this._renderer2.addClass(this._elementRef.nativeElement, 'clickable');
        }
    }

    onClick() {
        this.sopoTooltipService.showTooltip(this.appSopoTooltip(), this._elementRef.nativeElement);
    }
}
